import { useQuery } from "@tanstack/react-query";
import {
  PRERECORDED_VOICEMAILS_QUERY_KEY,
  prerecordedVoicemailsApi
} from "api/prerecordedVoicemails";

// CRM-1830: the company's pre-recorded voicemails, for the call card's Leave
// voicemail button and its list. Fetched only on an answered outgoing call;
// admins' edits on Phone numbers refresh it.
export const usePickableVoicemails = (enabled: boolean) =>
  useQuery({
    queryKey: PRERECORDED_VOICEMAILS_QUERY_KEY,
    queryFn: prerecordedVoicemailsApi.list,
    enabled,
    staleTime: 30_000
  });
